import { FC } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { t } from 'i18next';
import { commonTranslations, errors } from '../../../translations';
import { Animation, Animations } from '../animation/Animation';
import { Container, OverlayContainer } from './LoadingOverlay.styles';

export type LoadingOverlayProps = {
  isLoading: boolean;
  isError?: boolean;
  errorText?: string;
  actionText?: string;
  action?: () => void;
};

export const LoadingOverlay: FC<React.PropsWithChildren<LoadingOverlayProps>> = (props) => {
  const { isLoading, isError = false, children, errorText, actionText, action } = props;
  return (
    <Container>
      {(isLoading || isError) && (
        <OverlayContainer>
          {isLoading && <CircularProgress data-testid="loading-overlay-loader" size={24} thickness={3} />}

          {isError && (
            <Animation
              animation={Animations.NONE}
              title={''}
              subtitle={errorText || t(errors.sorry.key, errors.sorry.defaultValue)}
              size="small"
              button={{
                label: actionText || t(commonTranslations.tryAgain.key, commonTranslations.tryAgain.defaultValue),
                onClick: () => action && action(),
              }}
            />
          )}
        </OverlayContainer>
      )}

      {children}
    </Container>
  );
};
